export default __webpack_public_path__ + "static/media/heating.aa75b433.jpg";